import React, { useState } from "react";

export default function DropDownList({
  value,
  presetValues = [],
  setValue,
  setId,
}) {
  const [selectedOption, setSelectedOption] = useState(value);

  const handleInputChange = (event) => {
    setSelectedOption(event.target.value);
  };
  return (
    <div className="">
      <select
        className="select select-bordered select-sm w-full h-10"
        value={selectedOption}
        defaultValue={{ label: "Choose", value: "placeholder" }}
        onChange={(e) => {
          handleInputChange(e);
          setValue(e);
        }}
      >
        <option value="placeholder" hidden>
          Choose
        </option>
        {presetValues.map((value) => (
          <option key={value.value} value={value.value}>
            {value.value}
          </option>
        ))}
      </select>
    </div>
  );
}
